<template>
    <billing-dialog
      class="zsched-detail-dialog"
      :visible.sync="visible"
      @close="handleCancel"
      @back-event="handleCancel"
    >
      <h1 class="zsched-detail-dialog__title">{{ planCategoryName }}</h1>
      <price-list class="zsched-detail-dialog__price-list" :showDecimalPoint="$context.is.desktop" :plan-category="planCategory" :unit-type="planUnitMap.user"/>
        <ul class="zsched-detail-dialog__feature">
            <li class="zsched-detail-dialog__feature-item"
                v-html="$t('billing.scheduler.plan_details.simplify_bookings')">
            </li>
            <li class="zsched-detail-dialog__feature-item"
                v-html="$t('billing.scheduler.plan_details.host_one_on_one')">
            </li>
            <li class="zsched-detail-dialog__feature-item"
                v-html="$t('billing.scheduler.plan_details.customize_reminders')">
            </li>
            <li class="zsched-detail-dialog__feature-item"
                v-html="$t('billing.scheduler.plan_details.sync_calendars')">
            </li>
        </ul>
    </billing-dialog>
</template>
<script type="text/jsx">
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import PriceList from "@/components/price-list.vue";
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
    name: 'PlanDetails',
    mixins: [ConfirmComponent],
    components: {
      BillingDialog,
      PriceList,
    },
    props: {
        planCategory: String,
    },
    data() {
        return {
            visible: false,
            currencySymbol: getCurrencySymbol(getCurrency()),
            essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
            planUnitMap,
        };
    },
    computed: {
        planCategoryName() {
            return this.$t("billing.scheduler.title");
        },
    },
    watch: {
      visible(newVal, oldVal) {
        if (oldVal && !newVal) {
          this.$tracking.buyInteraction(
            'product details',
            `zoom scheduler plan details - exit`,
            `Direct Purchase, pricing new add-ons, billing new add-ons`
          );
        }
      }
    },
    mounted() {
        this.$tracking.buyInteraction(
            'product details',
            `zoom scheduler plan details - impression`,
            `Direct Purchase, pricing new add-ons, billing new add-ons`
        );
    }
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.zsched-detail-dialog {
    .zm-dialog {
        min-width: 522px;
        padding: 70px 60px;
        width: fit-content;
    }

    &__title {
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 150%;
        color: #00053D;
    }

    &__price-list {
        margin-bottom: 16px;
        @include media(mobile) {
            margin-top: 12px;
        }
    }

    &__feature {
        &-title {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 150%;
            color: #00053D;
        }

        &-item {
            position: relative;
            padding-left: 20px;
            margin-bottom: 16px;

            &::before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                background-image: url('../../../assets/Vector.svg');
                background-repeat: no-repeat;
                background-size: cover;
                width: 16px;
                height: 21px;
                font-size: 20px;
                font-weight: 700;
            }
        }

        &-item-name {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 21px;
            color: #00053D;
            @include darkTextColor;
        }

        &-item-content {
            font-style: normal;
            font-weight: 450;
            font-size: 12px;
            line-height: 18px;
            color: #666487;
            @include darkTextColor2;
        }
    }
}</style>
